import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import { setLenis, getLenis } from "@/lib/lenis";
import Preloader from "@/components/Preloader";
import CustomCursor from "@/components/CustomCursor";
import Navbar from "@/components/Navbar";
import Home from "@/pages/Home";
import ProjectPage from "@/pages/ProjectPage";
import { Impressum, Datenschutz } from "@/pages/Legal";

function ScrollManager() {
    const { pathname } = useLocation();
    useEffect(() => {
        const lenis = getLenis();
        if (lenis) lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

function App() {
    const [introDone, setIntroDone] = useState(false);

    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        setLenis(lenis);
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="App">
            <CustomCursor />
            <AnimatePresence>
                {!introDone && <Preloader key="preloader" onDone={() => setIntroDone(true)} />}
            </AnimatePresence>
            <BrowserRouter>
                <ScrollManager />
                <Navbar />
                <Routes>
                    <Route path="/" element={<Home introDone={introDone} />} />
                    <Route path="/projekt/:slug" element={<ProjectPage />} />
                    <Route path="/impressum" element={<Impressum />} />
                    <Route path="/datenschutz" element={<Datenschutz />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="bottom-center" theme="dark" />
        </div>
    );
}

export default App;
